<!-- 
LayoutPicker checks the router meta "layout" key to load the layout requested
by the router. When meta is absent, the wrapping is just a div.
Inspired by https://itnext.io/vue-tricks-smart-layouts-for-vuejs-5c61a472b69b
-->
<template>
  <!-- <LoaderOverlay :is-loading="isLoadingLayout" :opaque-background="true"> -->
  <component :is="layout" v-if="!isLoadingLayout" class="display-contents">
    <slot />
  </component>
  <!-- </LoaderOverlay> -->
</template>

<script>
import { ref, shallowRef, computed, watch } from 'vue'
import { useRoute } from 'vue-router'

const LAYOUT_MAP = {
  BaseLayout: () => import('../layouts/BaseLayout.vue'),
  BaseMenuLayout: () => import('../layouts/BaseMenuLayout.vue'),
  DefaultLayout: () => import('../layouts/DefaultLayout.vue'),
  MenuLayout: () => import('../layouts/MenuLayout.vue'),
}

export default {
  name: 'LayoutPicker',
  setup() {
    const route = useRoute()
    const layout = shallowRef('div')
    const isLoadingLayout = ref(true)

    const metaLayout = computed(() => route.meta?.layout || 'DefaultLayout')

    const loadLayoutComponent = async (layoutName) => {
      isLoadingLayout.value = true
      try {
        if (layoutName === 'div') layout.value = 'div'
        else if (LAYOUT_MAP[layoutName]) {
          const componentAsync = await LAYOUT_MAP[layoutName]()
          maybeSwapLayout(layoutName, componentAsync?.default)
        } else {
          console.error(`Unknown layout: ${layoutName}`)
          layout.value = 'div'
        }
      } catch (e) {
        console.error('Could not load layout. Error:', e)
        layout.value = 'div'
      } finally {
        isLoadingLayout.value = false
      }
    }

    const maybeSwapLayout = (layoutName, layoutComponent) => {
      /* Swap layout only if the route meta has not changed yet */
      /* This avoids race conditions with slower component loads */
      if (layoutName === metaLayout.value) layout.value = layoutComponent
    }

    watch(
      () => metaLayout.value,
      (layoutName) => loadLayoutComponent(layoutName),
      { immediate: true },
    )
    return { isLoadingLayout, layout }
  },
}
</script>
